import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { setActiveApp } from "../../../store";
import _ from "../../../i18n";
import MenuItem from "./MenuItem";
import styles from "./Header.module.scss";

const appIcons = {
  BLOG: "blog.svg",
  FAQ: "faq.svg",
  DASHBOARD: "dashboard.svg",
  POWERTEAM: "powerteam.svg",
  WEBTOOLS: "webtools.svg",
  OFFFCOURSE: "offfcourse.svg",
  NEWSLETTER: "sending.svg",
  AI: "talk.svg",
  LMS: "lms.svg",
  EVENT: "event.svg",
  PAPER: "paper.svg",
  PROBOSS: "proboss.svg",
};

const appLabels = {
  BLOG: "Blog",
  FAQ: _("help_center_app"),
  DASHBOARD: _("dashboard_app"),
  POWERTEAM: _("powerteam_app"),
  WEBTOOLS: _("webtools_app"),
  OFFFCOURSE: _("watch_app"),
  NEWSLETTER: "E-News",
  LMS: "LMS",
  EVENT: "Event",
  AI: "Artificial intelligence",
  PAPER: "Paper BO",
  PROBOSS: "PROBOSS",
};

export default function Apps({ language = "fr" }) {
  const portalApps = useSelector((state) => state.params.portalApps);
  const activeApp = useSelector((state) => state.params.activeApp);
  const fiduciary = useSelector((state) => state.folder.fiduciary);
  const currentPortal = useSelector((state) => state.params.currentPortal);
  const [tools, setTools] = useState([]);
  const auth = useSelector((state) => state.auth);
  const { user } = auth;
  const dispatch = useDispatch();

  useEffect(() => {
    if (fiduciary) {
      const preferences = fiduciary[`newsletterPreferences`];
      if (preferences && preferences.apps) setTools(preferences.apps);
      else setTools([]);
    } else {
      setTools([]);
    }
  }, [fiduciary]);

  if (portalApps.length === 0) {
    return null;
  }
  let roles = [];
  console.log("user.blogRole: ", user?.blogRole);
  if (Array.isArray(user?.blogRole)) {
    if (
      user.blogRole.length > 0 &&
      Array.isArray(user.blogRole[0]?.blogRoleInOrganization)
    ) {

      roles = user.blogRole[0].blogRoleInOrganization;
    } else {
      console.log("Unexpected blogRole structure: ", user.blogRole);
      roles = user.blogRole;
    }
  } else {
    console.log("blogRole is not an array: ", user.blogRole);
    roles = user.blogRole?.blogRoleInOrganization
  }
  //   const blogRole = user.blogRole.blogRoleInOrganization?.filter(
  //   (t) => t.organizationId === fiduciary?.id && t.role === "CHIEF_EDITOR"
  // );
  const blogRole = roles?.filter(
    (t) =>
      t.role === "CHIEF_EDITOR" &&
      (!fiduciary || t.organizationId === fiduciary?.id)
  );
  console.log("blogRole ======= rs", blogRole, user.blogRole, fiduciary);
  let isNewsletterCreate =
    tools.length > 0 &&
    tools.filter((t) => t.type === "BLOG_NL_CREATE").length > 0 &&
    blogRole &&
    blogRole.length > 0;

  return (
    <MenuItem icon="Apps" className={styles.apps}>
      <div className={styles.socialLinksWrapper}>
        <div className={styles.socialLinksHeader}> Applications </div>
        <div className={styles.socialLinksBody}>
          <ul className={styles.appsContainer}>
            {portalApps.map(
              (app) =>
                (app.id != "NEWSLETTER" ||
                  (app.id === "NEWSLETTER" && isNewsletterCreate)) && (
                  <li
                    key={app.id}
                    onClick={() => {
                      dispatch(setActiveApp(app.id));
                      window.history.replaceState(null, null, "?APP=" + app.id);
                    }}
                    className={`${styles.appsColumn} ${
                      activeApp === app.id && styles.appsActive
                    }`}
                  >
                    <div className={`${styles.appWrapper}`}>
                      {appIcons[app.id] && (
                        <img src={`img/apps/${appIcons[app.id]}`} alt="" />
                      )}
                      <div className={styles.appName}>
                        {appLabels[app.id] ? appLabels[app.id] : app.id}
                      </div>
                    </div>
                  </li>
                )
            )}
            {["COLLABORATOR", "CLIENT"].includes(currentPortal) &&
              fiduciary?.hasMastery && (
                <li
                  className={`${styles.appsColumn} ${
                    activeApp === "MASTERY" && styles.appsActive
                  }`}
                  onClick={() => {
                    dispatch(setActiveApp("MASTERY"));
                    window.history.replaceState(null, null, "?APP=MASTERY");
                  }}
                >
                  <div className={`${styles.appWrapper}`}>
                    <img src={`img/apps/mastery-pro.svg`} alt="" />

                    <div className={styles.appName}>Mastery</div>
                  </div>
                </li>
              )}
          </ul>
        </div>
      </div>
    </MenuItem>
  );
}
